import { render, staticRenderFns } from "./purchase-daily.vue?vue&type=template&id=2b1e0b94&scoped=true&"
import script from "./purchase-daily.vue?vue&type=script&lang=js&"
export * from "./purchase-daily.vue?vue&type=script&lang=js&"
import style0 from "./purchase-daily.vue?vue&type=style&index=0&id=2b1e0b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e0b94",
  null
  
)

export default component.exports